<template>
  <div class="buy">
    <div class="buyTitle">
        <h2><span class="back" @click.stop="back()"></span>开通会员</h2>
        <h3>
            <div class="huiyuan" :class="{'on':tab===0}" @click="tab=0">找铺会员 <span></span></div>
            <div class="xuanzhi" :class="{'on':tab===1}" @click="tab=1">转铺会员<span></span></div>
            <div class="zhuanpu" :class="{'on':tab===2}" @click="tab=2">VIP选址顾问<span></span></div>
            <div class="zhuanpu" :class="{'on':tab===3}" @click="tab=3">VIP转铺顾问<span></span></div>
        </h3>
    </div>
    <div class="content">
        <ul>
            <!-- 找铺会员 -->
            <li v-show="tab===0" class="huiyuan">
                <div class="zhuanpu-bg">
                    <div class="zhuanpu-title">
                        <div class="title-txt">已有 <span>18376</span> 位用户成功升级</div>
                        <div class="title-msg clearfix">
                            <ul>
                                <li v-for="(item,index) in seekShopMemberArr">
                                    <span>{{item.dsc}}</span>
                                    <b>{{item.price}}元</b>
                                    <i @click="huiyuanbuy(item)">购买</i>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="zhuanpu-liucheng">
                        <h3>找铺会员专享特权</h3>
                        <dl class="clearfix">
                            <dt></dt>
                            <dd>
                                <h5>每天查看30套铺源</h5>
                                <p>每日查看铺源从5套增加到30套，店主电话随意拨打</p>
                            </dd>
                        </dl>
                        <dl class="clearfix">
                            <dt class="other"></dt>
                            <dd>
                                <h5>新上热门铺源抢先看</h5>
                                <p>新上热门铺源48小时内只对会员开放，看铺抢先一步</p>
                            </dd>
                        </dl>
                        <dl class="zhuanpu-wenti">
                            <dd>
                            		<h5>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; 
                            			中国转店找铺端口</h5>
                                <p>真实房源，优铺核实; 在线服务，一对一咨询; 优铺拍店能让当天空铺立即上线</p>
                            </dd>
                        </dl>
                        <!-- <dl class="clearfix">
                            <dt class="two"></dt>
                            <dd>
                                <h5>商铺资质免费审核</h5>
                                <p>商铺证照、产权专业顾问审核，确保商铺合规</p>
                            </dd>
                        </dl> -->
                        <!-- <dl class="clearfix">
                            <dt class="three"></dt>
                            <dd>
                                <h5>拆迁风险免费评估</h5>
                                <p>权威机构拆迁风险评估，顾问陪同实地勘验</p>
                            </dd>
                        </dl> -->
                        <!-- <dl class="clearfix">
                            <dt class="four"></dt>
                            <dd>
                                <h5>转让费免费评估</h5>
                                <p>转让费平均虚高3成，专业顾问一对一评估，确保实价</p>
                            </dd>
                        </dl> -->
                       <!-- <dl class="clearfix cur">
                            <dt class="five"></dt>
                            <dd>
                                <h5>协助谈判议价</h5>
                                <p>专业顾问全程协助谈判议价，如高出个人自行谈判价格，赔</p>
                                <p class="cur">差价</p>
                            </dd>
                        </dl> -->
                        <!-- <dl class="clearfix">
                            <dt class="six"></dt>
                            <dd>
                                <h5>交易过户担保</h5>
                                <p>免费提供标准合同，转让费过户监管，零风险交付</p>
                            </dd>
                        </dl>-->
                        <!-- <dl class="clearfix">
                            <dt class="seven"></dt>
                            <dd>
                                <h5>开店专家经营指导</h5>
                                <p>数百位行业开店专家，免费指导经营，开店不再难</p>
                            </dd>
                        </dl> -->
                    </div>
                    <div class="zhuanpu-wenti">
                        <h3>问题解答</h3>
                        <div class="wenti-img"></div>
                    </div>
                    <div class="zhuangpu-tel"><b></b><s>服务咨询电话：010-85951005</s><b></b></div>
               </div>
            </li>
            <!-- 转铺会员 -->
            <li v-show="tab===1">
                <div class="turnShopMemberBox">
                    <img src="../../../static/images/turnShopMember/turnShopMemberBg.png">
                    <div class="turnShopMemberdiv">
                        <h3>您想购买多久的转铺会员呢？</h3>
                        <ul>
                            <li v-for="(item,index) in turnShopMemberArr">
                                <h5>{{item.dsc}}</h5>
                                <p>¥{{item.price}}</p>
                                <span @click="fuwubuy(item)">购买</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- <div class="turnShopMemberText">
                    <img src="../../../static/images/member/zhuanpu1.png" class="zhuanpu1">
                    <img src="../../../static/images/member/zhuanpu2.png" class="zhuanpu2">
                    <img src="../../../static/images/member/zhuanpu3.png" class="zhuanpu3">
                    <img src="../../../static/images/member/zhuanpu4.png" class="zhuanpu4">
                </div> -->
            </li>
            <!-- VIP选址服务 -->
            <li v-show="tab===2" class="xuanzhi">
                <div class="zhuanpu-bg">
                    <div class="dkhsWrap"></div>
                    <div class="zhuanpu-biaozhun">
                        <!-- <h3>VIP 选址服务收费标准(面积)</h3> -->
                        <div class="table">
                            <table>
                                <tr v-for="(item,index) in vipSiteServeArr">
                                    <td>{{item.dsc}}</td>
                                    <td>{{item.price}}元</td>
                                    <td>服务期3个月<span @click="xuanzhiFun(item)">立即购买</span></td>
                                </tr>
                            </table>
                        </div>
                    </div>

                    <!-- 6大安心服务承诺 -->
                    <div class="sixWrap"></div>

                    <!-- 委托选址 只需 5 步 -->
                    <div class="fiveWrap"></div>

                    <!-- 合作品牌 -->
                    <div class="brandWrap"></div>
                    
                    <!-- 服务咨询电话 -->
                    <div class="zhuangpu-tel"><b></b><s>服务咨询电话：010-85951005</s><b></b></div>
                </div>
            </li>
            <!-- VIP转铺服务 -->
            <li v-show="tab===3" class="xuanzhi">
                <div class="vipTurnShopServe-bg">

                    <div class="dkhs-vip-Wrap"></div>

                    <div class="zhuanpu-biaozhun">
                        <!-- <h3>VIP 转铺服务收费标准(年租金/转让费)</h3> -->
                        <div class="table">
                            <table>
                                <tr v-for="(item,index) in vipTurnShopServeArr">
                                    <td>{{item.dsc}}</td>
                                    <td>{{item.price}}元</td>
                                    <td>服务期3个月<span @click="trunShopServeFun(item)">立即购买</span></td>
                                </tr>
                            </table>
                        </div>
                    </div>
                    
                    <!-- 6大安心服务承诺 -->
                    <div class="six-vip-zp-wrap"></div>

                    <!-- 委托出租 只需 5 步 -->
                    <div class="five-vip-zp-wrap"></div>
                    
                    <!-- 战略合作 -->
                    <div class="cooperateWrap"></div>

                    <div class="zhuangpu-tel"><b></b><s>服务咨询电话：010-85951005</s><b></b></div>
                </div>
            </li>

        </ul>
    </div>
  </div>
</template>

<script>
import $ from '../../../static/js/jquery.min.js';
import axios from 'axios';
import qs from 'qs';
  export default {
    data(){
        return{
            tab:0,
            android: "",
            ios:"",
            news: "",
            shopId: "",
            shopDetail:"",
            price: 0,

            // 找铺会员
            seekShopMemberArr: [],
            // 转铺会员
            turnShopMemberArr: [],
            // vip选址服务
            vipSiteServeArr: [],
            // vip转铺服务
            vipTurnShopServeArr: []

        }
    },
    computed:{

    },
    mounted(){
        // 0 找铺会员 4 转铺会员 1 VIP选址服务 2 VIP转铺服务
        this.memberData(0); 
        this.memberData(4);
        this.memberData(1);
        this.memberData(2);

        //截取Url里面的参数
        function GetRequest() {
            var url = location.search; //获取url中"?"符后的字串
            var theRequest = new Object();
            if (url.indexOf("?") != -1) {
                var str = url.substr(1);
                var strs = str.split("&");
                for (var i = 0; i < strs.length; i++) {
                    theRequest[strs[i].split("=")[0]] = decodeURI(strs[i].split("=")[1]);
                }
            }
            return theRequest;
        }
        var request = new Object();
        request = GetRequest();

        var tab1 = request['tab'];

        if(tab1 == "1"){
            this.tab = 1;
        }else if(tab1 == "2"){
            this.tab = 2;
        }else if(tab1 == "3"){
            this.tab = 3;
        }else{
            this.tab = 0;
        }

    },
    methods:{
        back(){
            if(this.$route.query.mine){
                this.$router.push({path:"/mine"})
            }else if(this.$route.query.shopDetail){
                this.$router.push({path:"/shopDetail",query:{shopId:this.$route.query.shopId,buyMember:this.$route.query.shopDetail}})
            }else if(this.$route.query.payMember){
                this.$router.push({path:"/shopDetail",query:{shopId:this.$route.query.shopId,buyMember:this.$route.query.payMember}})
            }else if(this.$route.query.order){
                this.$router.push({path:"/order"})
            }else if(this.$route.query.url){
                this.$router.push({path:this.$route.query.url,query:{urlType:this.$route.query.urlType}})
            }else{
                this.$router.go(-1)
            }
        },
        // 购买会员
        huiyuanbuy(item){
            this.$router.push({path:"/payment",query:{"id":item.id,"price":item.price,buyMember:this.$route.query.shopDetail,shopId:this.$route.query.shopId}});
        },
        // 购买转铺会员
        fuwubuy(item){
            this.$router.push({path:"/payment",query:{"id":item.id,"price":item.price,buyMember:this.$route.query.shopDetail,shopId:this.$route.query.shopId,tab:"1"}});
        },
        // 购买VIP选址服务
        xuanzhiFun(item){
            this.$router.push({path:"/payment",query:{"id":item.id,"price":item.price,buyMember:this.$route.query.shopDetail,shopId:this.$route.query.shopId,tab:"2"}});
        },
        // 购买VIP转铺服务
        trunShopServeFun(item){
            this.$router.push({path:"/payment",query:{"id":item.id,"price":item.price,buyMember:this.$route.query.shopDetail,shopId:this.$route.query.shopId,tab:"3"}});
        },

        // 获取产品信息
        memberData(type){
            // 接口调用
            let _this = this;
            let url = _this.changeData() + '/member/selectProductList'
            axios(url,{
                method: 'post',
                // url: url,
                params: {
                    type: type, // 0 找铺会员 4 转铺会员 1 VIP选址服务  2 vip转铺服务
                    cityId: sessionStorage.cityId // 市id
                }
                // params: obj
            }).then(data => {

                if(type == 0){
                    // 找铺会员
                    this.seekShopMemberArr = data.data.productList;
                    // console.log(this.seekShopMemberArr);
                }else if(type == 4){
                    // 转铺会员
                    this.turnShopMemberArr = data.data.productList;
                    // console.log(this.turnShopMemberArr);
                }else if(type == 1){
                    // 转铺会员
                    this.vipSiteServeArr = data.data.productList;
                    // console.log(this.vipSiteServeArr);
                }else if(type == 2){
                    this.vipTurnShopServeArr = data.data.productList;
                }

            }).catch(err => {
                console.log(err)
            });
        }
    }
}
</script>

<style>
.layui-m-layer-tel .layui-m-layercont{
    padding: 35px 30px;
}
.layui-m-layer-tel h2{
    font-size: .32rem;
    color: #333;
    margin-bottom: .3rem;
}
.layui-m-layer-tel p{
    font-size: .36rem;
    color: #e8584f;
}
.layui-m-layer-tel .layui-m-layerbtn span:nth-of-type(1){
    color: #898989;
    background: #f7f8fa;
    font-size: .34rem;
    -webkit-tap-highlight-color: rgba(0,0,0,0);
}
.layui-m-layer-tel .layui-m-layerbtn span:nth-of-type(2){
    color: #fff;
    background: #64AAFF;
    font-size: .34rem;
    -webkit-tap-highlight-color: rgba(0,0,0,0);
    border-radius: 0 0 5px 0;
}
</style>
<style scoped lang="scss" type="text/scss">
.buy{
    width: 7.5rem;
    margin: 0 auto;
    background: #fff;
    .buyTitle{
        width: 7.5rem;
        line-height: 1rem;
        position: fixed;
        top: 0;
        z-index: 10000;
        background: #FFF;
        h2{
            height: .8rem;
            line-height: .8rem;
            color: #646464;
            font-size: .34rem;
            text-align: center;
            position: relative;
            span{
                -webkit-tap-highlight-color: rgba(0,0,0,0);
                width: 10%;
                height: .9rem;
                display: inline-block;
                width: .34rem;
                height: .34rem;
                margin-top: .3rem;
                margin-left: .2rem;
                background: url("../../../static/images/common/back.png") no-repeat;
                background-size: .34rem .34rem;
                position: absolute;
                left: .2rem;
                top: 0px;
            }
        }
        h3{
            display: flex;
            justify-content: space-around;
            .huiyuan,.xuanzhi,.zhuanpu{
                -webkit-tap-highlight-color: rgba(0,0,0,0);
                text-align: center;
                font-size: .28rem;
                color: #111;
                font-weight:bold;
                position: relative;
                span{
                    display: none;
                    width: .62rem;
                    height: .04rem;
                    background: #49ACFF;
                    position: absolute;
                    left: 50%;
                    margin-left:-.31rem;
                    bottom: 0;
                }
                &.on{
                   color: #49ACFF;
                  span{
                    display: block;
                  }
                }
            }
        }
    }
    .content{
        margin-top: 1.8rem;
        ul{
            li{
                background: #fff;
                &.huiyuan{
                    .zhuanpu-bg{
                        width: 7.5rem;
                        height: 8.8rem;
                        margin: 0 auto;
                        padding-top: 1.86rem;
                        border: 0.01rem solid #fff;
                        background: url("../../../static/images/member/huiyuan-bg.png") no-repeat #fff;
                        background-size: 7.5rem  4.8rem;
                        border: 0.01rem solid #fff;
                       .zhuanpu-title{
                            width: 7.1rem;
                            height: 4.8rem;
                            margin: 0 auto;
                            background: url("../../../static/images/member/huiyuan-title.png") no-repeat;
                            -webkit-background-size: 7.1rem 4.78rem;
                            background-size: 7.1rem 4.78rem;
                            .title-txt{
                                font-size: .34rem;
                                color: #111;
                                font-weight: bold;
                                text-align: center;
                                height: 1.4rem;
                                line-height: 1.4rem;
                                span{
                                    color: #EFAD00;
                                }
                            }
                            .title-msg{
                                height: 5.7rem;
                                padding:.5rem .54rem;
                                ul{
                                    li{
                                        width:6.28rem;
                                        height:.8rem;
                                        line-height: .8rem;
                                        background:rgba(255,255,255,1);
                                        box-shadow:0px 0px .1rem 0px rgba(255,86,0,0.15);
                                        border-radius:.06rem;
                                        margin-bottom: .2rem;
                                        span{
                                            display: inline-block;
                                            width: 2rem;
                                            text-align: center;
                                        }
                                        b{
                                            display: inline-block;
                                            width: 2rem;
                                            text-align: center;
                                            color: #F94200;
                                        }
                                        i{
                                            margin-left: .52rem;
                                            display: inline-block;
                                            width: 1.54rem;
                                            height: .8rem;
                                            background: #FF7F6F;
                                            text-align: center;
                                            color: #fff;
                                            font-size: .32rem;
                                        }
                                    }
                                }
                            }
                        }
                        .zhuanpu-liucheng{
                            width: 7.5rem;
                            background: #fff;
                            h3{
                                font-weight: bold;
                                font-size: .34rem;
                                font-weight: bold;
                                text-align: center;
                                padding: .7rem 0 .44rem;
                            }
                            dl{
                                margin-left: .3rem;
                                height: .96rem;
                                padding-bottom: .3rem;
                                &.cur{
                                    height: 1.4rem;
                                }
                            dt{
                                margin-top: .3rem;
                                margin-right: .3rem;
                                float: left;
                                width: .4rem;
                                height: .4rem;
                                background: url("../../../static/images/member/21.png") no-repeat;
                                -webkit-background-size: .4rem .4rem;
                                background-size: .4rem .4rem;
                            }
                            .two{
                                background: url("../../../static/images/member/22.png") no-repeat;
                                -webkit-background-size: .4rem .4rem;
                                background-size: .4rem .4rem;
                            }
                            .other{
                                background: url("../../../static/images/member/28.png") no-repeat;
                                -webkit-background-size: .4rem .4rem;
                                background-size: .4rem .4rem;
                            }
                            .three{
                                background: url("../../../static/images/member/23.png") no-repeat;
                                -webkit-background-size: .4rem .4rem;
                                background-size: .4rem .4rem;
                            }
                            .four{
                                background: url("../../../static/images/member/24.png") no-repeat;
                                -webkit-background-size: .4rem .4rem;
                                background-size: .4rem .4rem;
                            }
                            .five{
                                background: url("../../../static/images/member/25.png") no-repeat;
                                -webkit-background-size: .4rem .4rem;
                                background-size: .4rem .4rem;
                            }
                            .six{
                                background: url("../../../static/images/member/26.png") no-repeat;
                                -webkit-background-size: .4rem .4rem;
                                background-size: .4rem .4rem;
                            }
                            .seven{
                                background: url("../../../static/images/member/27.png") no-repeat;
                                -webkit-background-size: .4rem .4rem;
                                background-size: .4rem .4rem;
                            }
                            dd{
                                float: left;
                                h5{
                                  font-size: .3rem;
                                  color: #333;
                                }
                                p{
                                  font-size: .24rem;
                                  color: #666;
                                }
                            }
                        }
                    }
                    .zhuanpu-wenti{
                        background: #fff;
                        h3{
                            font-weight: bold;
                            font-size: .34rem;
                            font-weight: bold;
                            text-align: center;
                            padding: .7rem 0 .44rem;
                        }
                        .wenti-img{
                            width: 7.09rem;
                            height: 5.18rem;
                            margin: 0 auto;
                            background: url("../../../static/images/member/wenti-bg.png") no-repeat #fff;
                            -webkit-background-size: 7.09rem 5.18rem;
                            background-size: 7.09rem 5.18rem;
                        }
                    }
                    .zhuangpu-tel{
                        background: #fff;
                        text-align: center;
                        padding: .7rem 0;
                        b{
                            display: inline-block;
                            width: 1.53rem;
                            border: 0.01rem dashed #ccc;
                            vertical-align: middle;
                        }
                        s{
                            display: inline-block;
                            vertical-align: middle;
                            margin: 0 .1rem;
                            font-size: .28rem;
                        }
                    }
                }
            }
            &.xuanzhi{
                .zhuanpu-bg{
                    width: 7.5rem;
                    height: 8rem;
                    margin: 0 auto;
                    padding-top: 1.86rem;
                    border: 0.01rem solid #fff;
                    background: url("../../../static/images/member/xuanzhi-bg-new.png") no-repeat #fff;
                    background-size: 7.5rem  5.2rem;
                    .dkhsWrap{
                        width: 7.1rem;
                        height: 6.16rem;
                        background: url("../../../static/images/member/dkhs-vip-xz-new.png") no-repeat #fff;
                        background-size: 7.1rem  6.16rem;
                        border-radius: 6px;
                        margin: 0 auto;
                    }
                    .sixWrap{
                        width: 7.5rem;
                        height: 6.1rem;
                        background: url("../../../static/images/member/six-vip-xz-new.png") no-repeat #fff;
                        background-size: 7.5rem  6.1rem;
                    }
                    .fiveWrap{
                        width: 7.5rem;
                        height: 6.1rem;
                        background: url("../../../static/images/member/five-vip-xz.png") no-repeat #fff;
                        background-size: 7.5rem  6.1rem;
                    }
                    .brandWrap{
                        width: 7.5rem;
                        height: 9.22rem;
                        background: url("../../../static/images/member/brand.png") no-repeat #fff;
                        background-size: 7.5rem  9.22rem;
                    }
                    .zhuanpu-biaozhun{
                        background: #fff;
                        .table-title{
                            width: 7.1rem;
                            margin: 0 auto;
                            background: #49ACFF;
                            text-align: center;
                            height: .6rem;
                            line-height: .6rem;
                            color: #fff;
                            font-size: .3rem;
                        }
                        .table{
                            background: #fff;
                            margin: 0 .2rem;
                            padding: 0 .2rem;
                            border: 1px solid #2F7AF7;
                            background: #EBF6FE;
                            border-radius: 8px;
                            table{
                                width: 100%;
                                text-align: center;
                                tr{
                                    margin: 0 .2rem;
                                    border-bottom: 1px dashed #49acff;
                                    text-align: center;
                                    td{
                                        height: 1.10rem;
                                        line-height: 1.10rem;
                                        font-size: .28rem;
                                        color: #333;
                                        width: .8rem;
                                        span{
                                            -webkit-tap-highlight-color: rgba(0,0,0,0);
                                            display: inline-block;
                                            width: 1.6rem;
                                            height: .68rem;
                                            line-height: .68rem;
                                            margin-left: .4rem;
                                            color: #fff;
                                            text-align: center;
                                            background: #DF4646;
                                            background-size: 1.78rem .86rem;
                                            border-radius: 34px;
                                        }
                                    }
                                }
                                tr:nth-of-type(5){
                                    border-bottom: none;
                                }
                            }
                        }
                    }
                }
                .vipTurnShopServe-bg{
                    width: 7.5rem;
                    height: 8rem;
                    margin: 0 auto;
                    padding-top: 1.86rem;
                    border: 0.01rem solid #fff;
                    background: url("../../../static/images/member/zhuanpu-bg-new.png") no-repeat #fff;
                    background-size: 7.5rem  5.2rem;
                    .dkhs-vip-Wrap{
                        width: 7.1rem;
                        height: 6.14rem;
                        background: url("../../../static/images/member/dkhs-vip-zp-new.png") no-repeat #fff;
                        background-size: 7.1rem  6.14rem;
                        margin: 0 auto;
                        border-radius: 6px;
                    }
                    .six-vip-zp-wrap{
                        width: 7.5rem;
                        height: 5.6rem;
                        background: url("../../../static/images/member/six-vip-zp.png") no-repeat #fff;
                        background-size: 7.5rem 5.6rem;
                    }
                    .five-vip-zp-wrap{
                        width: 7.5rem;
                        height: 6.6rem;
                        background: url("../../../static/images/member/five-vip-zp.png") no-repeat #fff;
                        background-size: 7.5rem 6.6rem;
                    }
                    .zhuanpu-biaozhun{
                        background: #fff;
                        .table-title{
                            width: 7.1rem;
                            margin: 0 auto;
                            background: #49ACFF;
                            text-align: center;
                            height: .6rem;
                            line-height: .6rem;
                            color: #fff;
                            font-size: .3rem;
                        }
                        .table{
                            background: #fff;
                            margin: 0 .2rem;
                            padding: 0 .2rem;
                            border: 1px solid #DF4646;
                            background: #FBF5F5;
                            border-radius: 8px;
                            table{
                                width: 100%;
                                text-align: center;
                                tr{
                                    margin: 0 .2rem;
                                    border-bottom: 1px dashed #DF4646;
                                    text-align: center;
                                    td{
                                        height: 1.10rem;
                                        line-height: 1.10rem;
                                        font-size: .28rem;
                                        color: #333;
                                        width: .8rem;
                                        span{
                                            -webkit-tap-highlight-color: rgba(0,0,0,0);
                                            display: inline-block;
                                            width: 1.6rem;
                                            height: .68rem;
                                            line-height: .68rem;
                                            margin-left: .4rem;
                                            color: #fff;
                                            text-align: center;
                                            background: #2F7AF7;
                                            background-size: 1.78rem .86rem;
                                            border-radius: 34px;
                                        }
                                    }
                                }
                                tr:nth-of-type(5){
                                    border-bottom: none;
                                }
                            }
                        }
                    }
                    .cooperateWrap{
                        width: 7.5rem;
                        height: 2.6rem;
                        background: url("../../../static/images/member/cooperate.png") no-repeat #fff;
                        background-size: 7.5rem 2.6rem;
                    }
                }
            }
        }
      }
    }
}

/* 转铺会员 */
.turnShopMemberBox{
    width: 7.5rem;
    height: 6.7rem;
    position: relative;
    background: #fff;
    img{
        width: 7.5rem;
        height: 4.06rem;
    }
    .turnShopMemberdiv{
        width: 6.1rem;
        height: 3.04rem;
        padding: .4rem;
        background: rgba(255,255,255,1);
        box-shadow: 0px 8px 38px 0px rgba(0,0,0,0.1);
        border-radius: 14px;
        position: absolute;
        left: .3rem;
        bottom: 0;
        h3{
            color: #444;
            font-size: .3rem;
            font-weight: 600;
            margin-bottom: .3rem;
        }
        ul{
            li{
                width: 1.8rem;
                height: 2.2rem;
                float: left;
                background:rgba(255,255,255,1);
                border: 2px solid rgba(249,218,73,1);
                border-radius:10px;
                margin-left: .34rem;
                box-sizing: border-box;
                text-align: center;
                position: relative;
                overflow: hidden;
                h5{
                    color: #999999;
                    font-size: .3rem;
                    margin-top: .34rem;
                    margin-bottom: .1rem;
                }
                p{
                    color: #444444;
                    font-size: .36rem;
                    font-weight: 600;

                }
                span{
                    width: 1.72rem;
                    height: .5rem;
                    background: #f9da49;
                    display: inline-block;
                    color: #fff;
                    font-size: .3rem;
                    line-height: .5rem;
                    position: absolute;
                    bottom: 0rem;
                    left: 0rem;
                }
            }
            li:first-child{
                margin-left: 0rem;
            }
        }
    }
}
.turnShopMemberText{
    padding-top: .58rem;
    .zhuanpu1{
        width: 7.5rem;
        height: 5.45rem;
        img{
            width: 100%;
            height: 100%;
        }
    }

    .zhuanpu2{
        width: 7.5rem;
        height: 6.42rem;
        img{
            width: 100%;
            height: 100%;
        }
    }

    .zhuanpu3{
        width: 7.5rem;
        height: 7.8rem;
        img{
            width: 100%;
            height: 100%;
        }
    }

    .zhuanpu4{
        width: 7.5rem;
        height: 3.1rem;
        img{
            width: 100%;
            height: 100%;
        }
    }
}

/*服务咨询电话*/
.zhuangpu-tel{
    background: #fff;
    text-align: center;
    padding: .5rem 0 .7rem;
    b{
        display: inline-block;
        width: 1.53rem;
        border: 0.01rem dashed #ccc;
        vertical-align: middle;
    }
    s{
        display: inline-block;
        vertical-align: middle;
        margin: 0 .1rem;
        font-size: .28rem;
    }
}

</style>



// WEBPACK FOOTER //
// src/components/mine/buymember.vue